// extracted by mini-css-extract-plugin
export default {"advertisement-img-box":"rRKgMt241uAywdN2kafK","advertisement-img":"Vf67Lz10k2OBZmSXlLHf","type-default":"NsNc_Y6eGuF4QrxKoaL6","common_bganimation":"xozdn1EQZZYT4K7aVLWa"};